export default {
  // Page title
  'page.title': 'टाइमर',

  // Popular timers
  'popular.title': 'लोकप्रिय टाइमर',
  'popular.10s': '10 सेकंड टाइमर',
  'popular.20s': '20 सेकंड टाइमर',
  'popular.30s': '30 सेकंड टाइमर',
  'popular.40s': '40 सेकंड टाइमर',
  'popular.50s': '50 सेकंड टाइमर',
  'popular.90s': '1.5 मिनट टाइमर',
  'popular.2minute': '2 मिनट टाइमर',
  'popular.3minute': '3 मिनट टाइमर',
  'popular.5minute': '5 मिनट टाइमर',
  'popular.10minute': '10 मिनट टाइमर',
  'popular.15minute': '15 मिनट टाइमर',
  'popular.30minute': '30 मिनट टाइमर',
  'popular.60minute': '60 मिनट टाइमर',
  'popular.1hour': '1 घंटे का टाइमर',
  'popular.10hour': '10 घंटे का टाइमर',
  'popular.24hour': '24 घंटे का टाइमर',
  'popular.48hour': '48 घंटे का टाइमर',

  // How to use
  'howto.title': 'टाइमर कैसे सेट करें',
  'howto.titleMinutes': '{{minutes}} मिनट टाइमर कैसे सेट करें',
  'howto.titleSeconds': '{{seconds}} सेकंड टाइमर कैसे सेट करें',
  'howto.titleHour': '{{hours}} घंटे का टाइमर कैसे सेट करें',
  'howto.titleHours': '{{hours}} घंटे का टाइमर कैसे सेट करें',
  'howto.step1': '⚙️ अपना समय सेट करें: समय को सीधे संपादित करने के लिए घंटे या मिनट की संख्या पर क्लिक करें। आप किसी भी कार्य के लिए 23 घंटे और 59 मिनट तक सेट कर सकते हैं।',
  'howto.step2': '⚡ त्वरित समय समायोजन: अपने टाइमर में तुरंत 30 सेकंड, 1 मिनट, 5 मिनट, 10 मिनट या 30 मिनट जोड़ने के लिए सुविधाजनक त्वरित-जोड़ बटन का उपयोग करें।',
  'howto.step3': '▶️ शुरू करें और नियंत्रण करें: काउंटडाउन शुरू करने के लिए "शुरू करें" पर क्लिक करें। आप ब्रेक लेने के लिए किसी भी समय रोक सकते हैं और तैयार होने पर फिर से शुरू कर सकते हैं, या शुरू से शुरू करने के लिए रीसेट कर सकते हैं।',
  'howto.step4': '🔔 सूचित हों: समय समाप्त होने पर डेस्कटॉप सूचनाएं और अनुकूलन योग्य ध्वनि अलर्ट प्राप्त करें। ऊपरी-दाएं कोने में ध्वनि को चालू/बंद करें।',
  'howto.step5': '🖥️ पूर्ण स्क्रीन मोड: विचलित मुक्त टाइमिंग के लिए पूर्ण स्क्रीन बटन पर क्लिक करें - प्रस्तुतियों, ध्यान या केंद्रित कार्य सत्रों के लिए बिल्कुल सही।',
  'howto.step6': '📱 हर जगह काम करता है: किसी भी डिवाइस पर उपयोग करें - डेस्कटॉप, टैबलेट या मोबाइल। कोई डाउनलोड की आवश्यकता नहीं, सीधे आपके ब्राउज़र में काम करता है।',

  // User review submission
  'reviewSubmission.title': 'अपना अनुभव साझा करें',
  'reviewSubmission.subtitle': 'अपना अनुभव साझा करके दूसरों को इस टाइमर की खोज में मदद करें',
  'reviewSubmission.ratingLabel': 'अपने अनुभव को रेट करें',
  'reviewSubmission.commentLabel': 'आपकी समीक्षा (वैकल्पिक)',
  'reviewSubmission.commentPlaceholder': 'हमें बताएं कि इस टाइमर ने आपको उत्पादकता, खाना पकाने, अध्ययन या किसी अन्य गतिविधियों में कैसे मदद की...',
  'reviewSubmission.nameLabel': 'आपका नाम (वैकल्पिक)',
  'reviewSubmission.namePlaceholder': 'हमें आपका नाम कैसे प्रदर्शित करना चाहिए?',
  'reviewSubmission.submitButton': 'समीक्षा सबमिट करें',
  'reviewSubmission.thankYou': 'आपकी समीक्षा के लिए धन्यवाद!',
  'reviewSubmission.thankYouMessage': 'आपकी प्रतिक्रिया हमें सुधारने में मदद करती है और दूसरों को हमारे टाइमर की खोज करने में मदद करती है।',
  'reviewSubmission.error': 'कृपया सबमिट करने से पहले एक रेटिंग चुनें।',

  // User reviews
  'reviews.title': 'हमारे उपयोगकर्ता क्या कहते हैं',
  'reviews.newReview': 'नई समीक्षा',
  'reviews.mikeZhang': 'मेरी उत्पादकता के लिए गेम-चेंजर! इस टाइमर के साथ पोमोडोरो तकनीक ने मुझे अपनी थीसिस समाप्त करने में मदद की। साफ इंटरफ़ेस, कोई विचलन नहीं।',
  'reviews.lisaLee': 'रसोई के समय के लिए बिल्कुल सही! अब कभी अंडे ज्यादा नहीं पकते। ध्वनि अलर्ट काफी तेज़ हैं लेकिन कष्टप्रद नहीं। मेरी बुजुर्ग मां भी इसे पसंद करती हैं।',
  'reviews.johnDeveloper': 'अब तक का सबसे अच्छा कोडिंग ब्रेक टाइमर! प्रीसेट बटन बहुत समय बचाते हैं। आंखों के तनाव को रोकने में मदद करता है और स्प्रिंट के दौरान मुझे केंद्रित रखता है।',
  'reviews.msChen': 'मेरे कक्षा प्रबंधन को बदल दिया! छात्र वास्तव में समयबद्ध गतिविधियों का आनंद लेते हैं। दृश्य काउंटडाउन सभी को व्यस्त रखता है।',
  'reviews.fitnessPro': 'HIIT वर्कआउट के लिए क्रांतिकारी! सटीक समय, पसीने वाले हाथों के साथ भी आसान नियंत्रण। मेरे ग्राहक पूर्ण स्क्रीन मोड को पसंद करते हैं।',
  'reviews.sarahMarketer': 'मेरी बैठक की दक्षता में 40% की वृद्धि! अब और अंतहीन चर्चा नहीं। समय सीमा निर्णय लेने के लिए मजबूर करती है और सभी को केंद्रित रखती है।',
  'reviews.tomChef': 'मेरे रेस्तरां रसोई में आवश्यक! पास्ता, स्टेक, सॉस - हर बार सही समय। कई त्वरित-जोड़ बटन प्रतिभाशाली हैं।',
  'reviews.amyStudent': 'अध्ययन गेम-चेंजर! प्रबंधनीय समय खंडों के साथ टालमटोल चक्र को तोड़ता है। इस विधि का उपयोग करके C ग्रेड से A तक गई।',
  'reviews.davidWriter': 'मेरे लेखक के ब्लॉक को ठीक किया! 15 मिनट की लेखन स्प्रिंट गति पैदा करती है। इस टाइमर की बदौलत इस महीने 3 लेख प्रकाशित किए।',
  'reviews.rachelTherapist': 'ग्राहकों के साथ ध्यान सत्रों के लिए बिल्कुल सही। कोमल अलर्ट शांतिपूर्ण वातावरण को नहीं तोड़ते। अत्यधिक पेशेवर।',
  // Preset timer specific reviews
  'reviews.managerZhang': 'कार्यालय कार्य के लिए आवश्यक! चाय बनाने और बैठक के ब्रेक के लिए बिल्कुल सही, साफ इंटरफ़ेस काम से विचलित नहीं करेगा।',
  'reviews.mrsLi': 'बिल्कुल सही अंडा टाइमर! 3 मिनट नरम-उबले अंडे हर बार सही निकलते हैं, ध्वनि अलर्ट बहुत विचारशील हैं, कोई अधिक पके अंडे नहीं।',
  'reviews.programmerWang': 'कोडिंग ब्रेक के दौरान आंखों के व्यायाम के लिए आवश्यक, 3 मिनट आंखों की मांसपेशियों को आराम देने के लिए बिल्कुल सही है, दृष्टि सुरक्षा के लिए बहुत बढ़िया!',

  // Use cases
  'useCases.title': '{{minutes}} मिनट टाइमर के उपयोग',
  'useCases.titleSeconds': '{{seconds}} सेकंड टाइमर के उपयोग',
  'useCases.titleHours': '{{hours}} घंटे टाइमर के उपयोग',

  // Page titles
  'pageTitle': '{{minutes}} मिनट टाइमर',
  'pageTitleSeconds': '{{seconds}} सेकंड टाइमर',
  'pageTitleHour': '{{hours}} घंटे का टाइमर',
  'pageTitleHours': '{{hours}} घंटे का टाइमर',

  // User names
  'user.mikeZhang': 'माइक झांग',
  'user.lisaLee': 'लिसा ली',
  'user.johnDeveloper': 'जॉन डेवलपर',
  'user.msChen': 'सुश्री चेन',
  'user.fitnessPro': 'फिटनेस प्रो',
  'user.sarahMarketer': 'सारा मार्केटर',
  'user.tomChef': 'टॉम शेफ',
  'user.amyStudent': 'एमी स्टूडेंट',
  'user.davidWriter': 'डेविड राइटर',
  'user.rachelTherapist': 'राचेल थेरेपिस्ट',
  // Preset timer specific users
  'user.managerZhang': 'प्रबंधक झांग',
  'user.mrsLi': 'श्रीमती ली',
  'user.programmerWang': 'प्रोग्रामर वांग',

  // Use cases
  'useCases.quickBreak.title': 'त्वरित ब्रेक',
  'useCases.quickBreak.desc': 'अपने दिमाग को ताज़ा करने और बर्नआउट को रोकने के लिए कार्य सत्रों के बीच छोटा ब्रेक',
  'useCases.eyeCare.title': 'आंखों की देखभाल अनुस्मारक',
  'useCases.eyeCare.desc': '20-20-20 नियम का पालन करें: हर 20 मिनट में, 20 सेकंड के लिए 20 फीट दूर किसी चीज़ को देखें',
  'useCases.teaBrewing.title': 'चाय बनाना',
  'useCases.teaBrewing.desc': 'हरी चाय (3 मिनट), काली चाय (5 मिनट), या हर्बल मिश्रणों के लिए सही समय',
  'useCases.lightExercise.title': 'हल्का व्यायाम',
  'useCases.lightExercise.desc': 'कार्यालय में स्ट्रेचिंग, डेस्क योग, या गतिहीन जीवन शैली से लड़ने के लिए सरल व्यायाम',
  'useCases.meditation.title': 'माइंडफुलनेस और ध्यान',
  'useCases.meditation.desc': 'निर्देशित सांस लेने के व्यायाम, माइंडफुलनेस अभ्यास, या तनाव राहत ध्यान',
  'useCases.softBoiledEggs.title': 'खाना पकाने का टाइमर',
  'useCases.softBoiledEggs.desc': 'नरम-उबले अंडे (5 मिनट), पास्ता पकाने, या किसी भी रसोई कार्य के लिए सही समय',
  'useCases.quickReading.title': 'केंद्रित पढ़ना',
  'useCases.quickReading.desc': 'किताबों, लेखों या अध्ययन सामग्री के लिए केंद्रित पढ़ने के सत्र',
  'useCases.phoneCall.title': 'कॉल और बैठक टाइमर',
  'useCases.phoneCall.desc': 'फोन कॉल को ट्रैक पर रखें, बैठक की अवधि सीमित करें, या प्रस्तुतियों का समय रखें',
  'useCases.focusedWork.title': 'पोमोडोरो कार्य सत्र',
  'useCases.focusedWork.desc': 'क्लासिक पोमोडोरो तकनीक - ब्रेक के बाद 25 मिनट का केंद्रित कार्य',
  'useCases.exercise.title': 'वर्कआउट और प्रशिक्षण',
  'useCases.exercise.desc': 'उच्च-तीव्रता अंतराल, सर्किट प्रशिक्षण, या विशिष्ट व्यायाम अवधि',
  // 15-minute specific
  'useCases.shortMeeting.title': 'स्टैंड-अप बैठकें',
  'useCases.shortMeeting.desc': 'त्वरित टीम अपडेट, दैनिक स्टैंडअप, या संक्षिप्त सहयोगी चर्चा',
  'useCases.powerNap.title': 'पावर नैप',
  'useCases.powerNap.desc': 'बिना थकान के ऊर्जा बढ़ाने के लिए इष्टतम नींद की अवधि',
  'useCases.learning.title': 'सीखने के सत्र',
  'useCases.learning.desc': 'भाषा अभ्यास, कौशल ट्यूटोरियल, या शैक्षिक वीडियो खंड',
  'useCases.creativity.title': 'रचनात्मक स्प्रिंट',
  'useCases.creativity.desc': 'ब्रेनस्टॉर्मिंग सत्र, लेखन स्प्रिंट, या कलात्मक अभ्यास',
  // 30-minute specific
  'useCases.deepWork.title': 'गहन कार्य सत्र',
  'useCases.deepWork.desc': 'जटिल कार्यों के लिए न्यूनतम रुकावटों के साथ विस्तारित केंद्रित कार्य',
  'useCases.workout.title': 'पूर्ण वर्कआउट',
  'useCases.workout.desc': 'पूर्ण व्यायाम दिनचर्या, योग सत्र, या संरचित प्रशिक्षण कार्यक्रम',
  'useCases.study.title': 'अध्ययन ब्लॉक',
  'useCases.study.desc': 'परीक्षाओं, अनुसंधान या कौशल विकास के लिए गहन अध्ययन सत्र',
  'useCases.presentation.title': 'प्रस्तुति अभ्यास',
  'useCases.presentation.desc': 'भाषणों का पूर्वाभ्यास करें, पिचों का अभ्यास करें, या प्रस्तुति वितरण का समय रखें',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'एलेक्स ऑफिस',
  'user.developerSarah': 'सारा डेव',
  'user.designerMike': 'माइक डिज़ाइन',
  'reviews.officeWorkerAlex': 'बैठकों के बीच त्वरित ब्रेक के लिए बिल्कुल सही! सिर्फ 1 मिनट में स्ट्रेच करने और फिर से ध्यान केंद्रित करने से बहुत फर्क पड़ता है।',
  'reviews.developerSarah': '20-20-20 नियम के लिए बढ़िया - हर 20 मिनट में मैं 1 मिनट के लिए 20 फीट दूर किसी चीज़ को देखती हूं। मेरी आंखें बहुत बेहतर महसूस करती हैं!',
  'reviews.designerMike': 'मैं गहन डिज़ाइन कार्य के दौरान माइक्रो-ब्रेक के लिए इसका उपयोग करता हूं। छोटा लेकिन बर्नआउट को रोकने के लिए प्रभावी।',

  // 3-minute timer users
  'user.teaLoverEmily': 'एमिली टी',
  'user.yogatrainerJohn': 'जॉन योग',
  'user.busyMomLisa': 'लिसा मॉम',
  'reviews.teaLoverEmily': 'मेरी हरी चाय के लिए सही समय! 3 मिनट बिना कड़वाहट के सही स्वाद देता है। ध्वनि अलर्ट पसंद है!',
  'reviews.yogatrainerJohn': 'मैं ग्राहकों के साथ त्वरित सांस लेने के व्यायाम के लिए इसका उपयोग करता हूं। 3 मिनट शांत सत्र के लिए बिल्कुल सही है।',
  'reviews.busyMomLisa': 'मेरे बच्चों के दांत ब्रश करने के समय के लिए बढ़िया। अब वे वास्तव में काउंटडाउन का आनंद लेते हैं!',

  // 5-minute timer users
  'user.meditatorZen': 'ज़ेन मास्टर',
  'user.chefTony': 'शेफ टोनी',
  'user.runnerMia': 'मिया रनर',
  'reviews.meditatorZen': 'शुरुआती लोगों के ध्यान के लिए बिल्कुल सही। 5 मिनट माइंडफुलनेस अभ्यास के लिए प्रबंधनीय लेकिन प्रभावी है।',
  'reviews.chefTony': 'मेरी रसोई में आवश्यक! हर बार नरम-उबले अंडे के लिए सही समय। पेशेवर और विश्वसनीय।',
  'reviews.runnerMia': 'मैं दौड़ के बाद स्ट्रेचिंग के लिए इसका उपयोग करती हूं। 5 मिनट सुनिश्चित करता है कि मैं अपनी रिकवरी दिनचर्या को छोड़ूं नहीं!',

  // 10-minute timer users
  'user.studentDavid': 'डेविड स्टूडेंट',
  'user.managerRachel': 'राचेल मैनेजर',
  'user.writerJames': 'जेम्स राइटर',
  'reviews.studentDavid': 'अध्ययन ब्रेक के लिए बढ़िया! 10 मिनट गति खोए बिना मानसिक रीसेट के लिए बिल्कुल सही है।',
  'reviews.managerRachel': 'मैं केंद्रित पढ़ने के सत्रों के लिए इसका उपयोग करती हूं। 10 मिनट की बिना रुकावट की पढ़ाई वास्तव में जुड़ती है!',
  'reviews.writerJames': 'समयबद्ध लेखन स्प्रिंट के लिए बिल्कुल सही। 10 मिनट का दबाव मुझे लेखक के ब्लॉक को दूर करने में मदद करता है।',

  // 15-minute timer users
  'user.consultantAmy': 'एमी कंसल्टेंट',
  'user.teacherBen': 'बेन टीचर',
  'user.freelancerSophie': 'सोफी फ्रीलांसर',
  'reviews.consultantAmy': 'त्वरित ग्राहक कॉल और स्टैंड-अप बैठकों के लिए आदर्श। चर्चाओं को केंद्रित और उत्पादक रखता है।',
  'reviews.teacherBen': 'मैं कक्षा गतिविधियों और समूह कार्य के लिए इसका उपयोग करता हूं। छात्र समय सीमा के साथ व्यस्त रहते हैं।',
  'reviews.freelancerSophie': 'बिल्कुल सही पोमोडोरो सत्र! ब्रेक के बाद 15 मिनट का केंद्रित कार्य मुझे पूरे दिन उत्पादक रखता है।',

  // 30-minute timer users
  'user.executiveRobert': 'रॉबर्ट एग्जीक्यूटिव',
  'user.fitnessCoachMaya': 'माया फिटनेस',
  'user.artistOlivia': 'ओलिविया आर्टिस्ट',
  'reviews.executiveRobert': 'गहन कार्य सत्रों के लिए उत्कृष्ट। 30 मिनट भारी प्रतिबद्धता के बिना सार्थक प्रगति की अनुमति देता है।',
  'reviews.fitnessCoachMaya': 'पूर्ण वर्कआउट सर्किट के लिए बिल्कुल सही। मेरे ग्राहक विभिन्न व्यायामों के लिए संरचित समय को पसंद करते हैं।',
  'reviews.artistOlivia': 'रचनात्मक सत्रों के लिए बढ़िया। 30 मिनट प्रवाह की स्थिति में प्रवेश करने और कुछ सार्थक बनाने के लिए पर्याप्त समय देता है।',
};
